<rt-tabs layout-full-width padding-left>
  <rt-tab
    [class.current]="activeTab === RequisitionsListTab.Active"
    (click)="changeScope(RequisitionsScope.Active)"
  >
    <rt-icon name="pulse" />
    {{ 'app.requisitions.list.active_requisitions' | translate }}
  </rt-tab>
  <rt-tab
    [class.current]="activeTab === RequisitionsListTab.Archived"
    (click)="changeScope(RequisitionsScope.Archived)"
  >
    <rt-icon name="archive" />
    {{ 'app.requisitions.list.archived' | translate }}
  </rt-tab>
</rt-tabs>
<div class="toolbar" layout layout-space-between space-lr padding-top>
  @if (viewType === RequisitionsListViewType.Table) {
    <rt-bulk-actions-toolbar [context]="{ requisitionsScope: params.scope }" margin-right-small />
  }
  <rt-group layout-full-width>
    @if (activeTab === RequisitionsListTab.Active) {
      <rt-segmented-control
        [type]="'view-switcher'"
        [segmentedButtons]="segmentedFilterButtons"
        [noWrap]="true"
        (segmentedButtonClicked)="changeScope($event)"
        margin-right
      />
    }
    <rt-form-field class="search-field">
      <rt-input
        variant="rounded"
        [formControl]="queryControl"
        [placeholder]="'app.common.placeholders.search.requisitions.other' | translate"
        [hasClearButton]="true"
        (reset)="queryControl.setValue('')"
      >
        <rt-icon prefix name="search" />
      </rt-input>
    </rt-form-field>
  </rt-group>

  <rt-group class="stacked">
    @if (isNewRequisitionsButtonVisible) {
      <rt-button variant="primary" [disabled]="newRequisitionsDisabled" (click)="newRequisition()">
        <rt-icon name="add" />
        {{ 'app.requisitions.new_requisition' | translate }}
      </rt-button>
    }
    <rt-button
      #groupDropdownTrigger="rtOverlayOrigin"
      [dropdownOpened]="groupDropdown.open"
      (click)="groupDropdown.open = true"
      variant="tertiary"
      margin-left-small
      rt-overlay-origin
    >
      <rt-icon name="sort" />
      <span>{{ groupByButtonLabel }}</span>
    </rt-button>
    @if (viewType === RequisitionsListViewType.Table) {
      <rt-data-table-options-button
        [tableAutoFit]="tableConfig.autoFit"
        [tableColumns]="$any(tableConfig.allColumns)"
        (tableAutoFitChange)="changeTableConfig({ autoFit: $event })"
        (tableColumnsChange)="changeTableConfig({ columns: $event })"
        margin-left-small
      />
    }
    <rt-segmented-control
      [type]="'view-switcher'"
      [segmentedButtons]="segmentedViewTypeButtons"
      [noWrap]="true"
      (segmentedButtonClicked)="changeViewType($event)"
      margin-left-small
    />
  </rt-group>
</div>

<ng-template
  #groupDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="groupDropdownTrigger"
  (backdropClick)="groupDropdown.open = false"
>
  <rt-dropdown [width]="DropdownWidth.SmallX">
    <rt-dropdown-header>
      {{ 'app.requisitions.list.group_by.dropdown_header' | translate }}
    </rt-dropdown-header>
    @for (group of groups; track trackByIndex($index, group)) {
      <rt-dropdown-item (click)="changeGroup(group.kind)" [isSelected]="groupBy === group.kind">
        {{ group.text }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
